import { GoogleRepliesForACase } from '../../../../app/api'

export const REJECTION_REASONS = [
  'ad_not_found',
  'wrong_form',
  'multiple_trademarks',
  'trademark_not_found',
  'ad_complies_with_policy',
  'country_mismatch',
  'brand_as_keyword',
  'unknown',
] as const

export type TRejectionReason = (typeof REJECTION_REASONS)[number]

export const REGISTRATION_REJECTION_REASONS: TRejectionReason[] = [
  'trademark_not_found',
  'country_mismatch',
]

// Тип ответа, которого нет в справочнике отказов, как и пустой, показываем «View reply to see why»
export const toRejectionReason = (
  replyType: GoogleRepliesForACase['reply_type'],
): TRejectionReason => REJECTION_REASONS.find((reason) => reason === replyType) ?? 'unknown'
